module.exports = __webpack_public_path__ + "media/img/icons/home-ea676254705b3939870e2f94997fcc43.svg";